// @flow
import type { Variant } from './duck';

import { experiments } from './experiments';
import {setCookie} from "../../utils/cookies";

function chooseCookieBasedVariant(cookie: string, experimentId: string, variants: Variant[]): Variant {
  // console.log('cookie', cookie);
  const gaexp = cookie && cookie.split(' ').find(x => x.startsWith('_gaexp'));
  // console.log('gaexp', gaexp);
  if (gaexp) {
    let gaexpContent = gaexp.split('=')[1];
    // Remove trailing semicolon
    // console.log('gaexpContent[gaexpContent.length - 1]', gaexpContent[gaexpContent.length - 1]);
    if (gaexpContent[gaexpContent.length - 1] === ';') {
      gaexpContent = gaexpContent.substring(0, gaexpContent.length - 1);
    }
    // console.log('gaexpContent', gaexpContent);
    // This variants has on them the exp id so we gotta extract them and match with each exp found
    const gaexpExperiments = gaexpContent.split('!');
    const gaexpExperiment = gaexpExperiments.find((v: string) => v.indexOf(experimentId) !== -1);
    // console.log('gaexpExperiment', gaexpExperiment);
    if (gaexpExperiment) {
      const selectedVariant = gaexpExperiment[gaexpExperiment.length - 1];
      const parsedSelected = parseInt(selectedVariant);
      if (!isNaN(parsedSelected)) {
        // console.log(`variants[${parsedSelected}]`, variants[parsedSelected]);
        return variants[parsedSelected];
      }
    }
  }
  // If nothing was found, return the first option
  return variants[0];
}

function getChosenVariant(chosenVariants?: { [key: string]: number }, expName: string): Variant {
  const chooseFnResult: Variant = chooseCookieBasedVariant(document ? document.cookie : '',
    experiments[expName].experimentId,
    experiments[expName].variants);
  const chosenVariantIndex = chosenVariants && chosenVariants[expName];
  return typeof chosenVariantIndex === 'number' ?
    experiments[expName].variants[chosenVariantIndex] : chooseFnResult;
}

function generateCookieBasedTest(abTestName: string) {
  setCookie('QEMPO_AB_TEST', abTestName);
}

function generateCookieBasedRandomVariant() {
  const variant = Math.random() > 0.5 ? 'a' : 'b';
  setCookie('QEMPO_AB_TEST_VARIANT', variant);
}

function deleteCookieBasedTest() {
  setCookie('QEMPO_AB_TEST', '', '0');
  setCookie('QEMPO_AB_TEST_VARIANT', '', '0');
}

const getCookie = (name: string) => {
  if (typeof document === 'undefined' || !name) return;

  let cookies = document.cookie ? document.cookie.split('; ') : [];
  let result;
  for (let i = 0; i < cookies.length; i++) {
    let parts = cookies[i].split('=');
    let value = parts.slice(1).join('=');
    try {
      let found = decodeURIComponent(parts[0]);
      if (name === found) {
        result = value;
        break;
      }
    } catch (e) {}
  }
  if (!result) return undefined;
  return result;
};

function getCookieBasedTest(): {test: string, variant: string} {
  /*const st = (document.cookie || '').split('; QEMPO_AB_TEST=');
  const sv = (document.cookie || '').split('; QEMPO_AB_TEST_VARIANT=');*/
  
  const st = getCookie('QEMPO_AB_TEST') || '';
  const sv = getCookie('QEMPO_AB_TEST_VARIANT') || '';
  
  if (st.length > 0 && sv.length > 0) {
    return {
      test: st[1],
      variant: sv[1],
    };
  }
  
  return {test: undefined, variant: undefined};
}

export {
  chooseCookieBasedVariant,
  getChosenVariant,
  generateCookieBasedTest,
  generateCookieBasedRandomVariant,
  deleteCookieBasedTest,
  getCookieBasedTest,
};



// WEBPACK FOOTER //
// ./src/modules/ab-test/utils.js